import { Component, Input } from '@angular/core';

@Component({
  selector: 'tangram-course-summary-panel',
  templateUrl: './course-summary-panel.component.html',
  styleUrls: ['./course-summary-panel.component.scss'],
})
export class CourseSummaryPanelComponent {
  @Input() summary: string = '';
  @Input() isLoading: boolean = false;

  expanded = true;

  get hasContent(): boolean {
    return !!(this.summary && this.summary.trim());
  }

  get bullets(): string[] {
    if (!this.summary) { return []; }
    return this.summary
      .split(/\n|•|-/)
      .map(s => s.trim())
      .filter(s => s.length > 0);
  }

  toggle(): void {
    this.expanded = !this.expanded;
  }
}
